import styled from 'styled-components';

export const TextFormat = styled.span`
  white-space: pre-wrap;

  a {
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;
